const notificationsActions = {

  NOTIFICATIONS_REQUESTED: 'NOTIFICATIONS_REQUESTED',
  NOTIFICATIONS_RECEIVED: 'NOTIFICATIONS_RECEIVED',
  REQUEST_EXTEND_NOTIFICATIONS: 'REQUEST_EXTEND_NOTIFICATIONS',
  EXTEND_NOTIFICATIONS: 'EXTEND_NOTIFICATIONS',
  MARK_NOTIFICATIONS_AS_SEEN: 'MARK_NOTIFICATIONS_AS_SEEN',
  MARK_NOTIFICATION_AS_INTERACTED: 'MARK_NOTIFICATION_AS_INTERACTED',
  SET_TRAY_OPEN: 'SET_TRAY_OPEN',
  SET_RELOAD: 'SET_RELOAD',
  INCREMENT_NEW_NOTIFICATION_COUNT: 'INCREMENT_NEW_MESSAGE_COUNT',

  incrementNewNotificationCount() {
    return { type: this.INCREMENT_NEW_NOTIFICATION_COUNT };
  },
  reload(state) {
    return { type: this.SET_RELOAD, reload: state };
  },
  requestNotifications() {
    return { type: this.NOTIFICATIONS_REQUESTED };
  },
  receiveNotifications(notifications, total, canExtend) {
    return {
      type: this.NOTIFICATIONS_RECEIVED, notifications, total, canExtend,
    };
  },
  markNotificationsAsSeen(notifications, markAllAsSeen) {
    return { type: this.MARK_NOTIFICATIONS_AS_SEEN, notifications, markAllAsSeen };
  },
  markNotificationAsInteracted(notification) {
    return { type: this.MARK_NOTIFICATION_AS_INTERACTED, notification };
  },
  requestExtendNotifications() {
    return { type: this.REQUEST_EXTEND_NOTIFICATIONS };
  },
  extendNotifications(notifications, total, canExtend) {
    return {
      type: this.EXTEND_NOTIFICATIONS, notifications, total, canExtend,
    };
  },
  setTrayOpen(open) {
    return { type: this.SET_TRAY_OPEN, open };
  },
};

export default notificationsActions;
